import { render } from "./KnowledgeDocPreview.vue?vue&type=template&id=4dab3959&scoped=true"
import script from "./KnowledgeDocPreview.vue?vue&type=script&lang=js"
export * from "./KnowledgeDocPreview.vue?vue&type=script&lang=js"

import "./KnowledgeDocPreview.vue?vue&type=style&index=0&id=4dab3959&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dab3959"]])

export default __exports__